import { IWizardStep } from './models/IWizardStep'

export type TPlanningWizardTranslationPrefix = 'jbp-planning-wizard'

export const JBP_PLANNING_WIZARD_TRANSLATION_PREFIX = 'jbp-planning-wizard-'
export const LOADER_DIMENSION = { width: 20, height: 20 }
export const IS_SHOW_HIDE_WIZARD_CHECKBOX = false
export const IS_SHOW_TEXT_COMPLETENESS = false

export const WIZARD_WELCOME_STEP: IWizardStep = {
  id: 'welcome-1',
  translationKey: "Let's Planning!",
  completeness: 0,
  widgetId: 'welcome',
  isApplicable: 1,
  isApplicableDisabled: 1,
  steporder: 0,
  wizgroup: '',
}
